import * as types from '../mutation-types'

const state = {
  types: JSON.parse(localStorage.getItem('monitoring_document_types')),
  search: JSON.parse(localStorage.getItem('monitoring_document_search')),
  images: JSON.parse(localStorage.getItem('image_document'))
}

const mutations = {
  [types.MONITORING_DOCUMENT_TYPES_RESET] (state) {
    state.search = null
    localStorage.removeItem('monitoring_document_types')
  },
  [types.MONITORING_SET_DOCUMENT_TYPES] (state, types) {
    state.types = types
    localStorage.setItem('monitoring_document_types', JSON.stringify(types))
  },
  [types.MONITORING_DOCUMENT_SEARCH_RESET] (state) {
    state.search = null
    localStorage.removeItem('monitoring_document_search')
  },
  [types.MONITORING_SET_DOCUMENT_SEARCH] (state, search) {
    state.search = {
      filter: search.filter,
      result: search.result,
      page: 1
    }
    localStorage.setItem('monitoring_document_search', JSON.stringify(state.search))
  },
  [types.MONITORING_SET_DOCUMENT_SEARCH_PAGE] (state, page) {
    state.search.page = page
    localStorage.setItem('monitoring_document_search', JSON.stringify(state.search))
  },
  [types.MONITORING_SET_DOCUMENT_IMAGE] (state, images) {
    state.images = images
    localStorage.setItem('monitoring_document_images', JSON.stringify(images))
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/monitoring.js